export default __webpack_public_path__ + "static/media/Nicholas Krsikap.52794414.png";